"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledText = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const tokens_1 = require("../../../styles/tokens");
const Responsive_1 = require("../../shared/Responsive");
const Text_constants_1 = require("./Text.constants");
const Text_utils_1 = require("./Text.utils");
exports.StyledText = styled_components_1.default.p `
    /**
     * Resetting font styles here to override default bootstrap styles in our projects
     */
    font-style: normal;
    font-family: "Roboto", sans-serif;
    font-weight: normal;
    line-height: 1.5rem;
    font-size: 1rem;
    margin-top: 0;
    margin-bottom: 0;

    color: ${(props) => (0, Text_utils_1.getColor)(props)};

    @media (max-width: ${tokens_1.BREAKPOINTS.md}) {
        ${({ $size }) => {
    return $size && (0, Responsive_1.responsiveMapToMedia)($size, Text_constants_1.smallScreenFontSizes);
}}
    }

    @media (min-width: ${tokens_1.BREAKPOINTS.md}) {
        ${({ $size }) => {
    return $size && (0, Responsive_1.responsiveMapToMedia)($size, Text_constants_1.largeScreenFontSizes);
}}
    }

    ${({ $weight }) => {
    return $weight && (0, Responsive_1.responsiveCssToMedia)($weight, "font-weight");
}}

    ${({ $m }) => {
    return $m && (0, Responsive_1.responsiveCssToMedia)($m, "margin");
}}

    ${({ $mx }) => {
    return $mx && (0, Responsive_1.responsiveCssToMedia)($mx, "margin-right");
}}

    ${({ $mx }) => {
    return $mx && (0, Responsive_1.responsiveCssToMedia)($mx, "margin-left");
}}

    ${({ $my }) => {
    return $my && (0, Responsive_1.responsiveCssToMedia)($my, "margin-top");
}}

    ${({ $my }) => {
    return $my && (0, Responsive_1.responsiveCssToMedia)($my, "margin-bottom");
}}

    ${({ $mt }) => {
    return $mt && (0, Responsive_1.responsiveCssToMedia)($mt, "margin-top");
}}

    ${({ $mr }) => {
    return $mr && (0, Responsive_1.responsiveCssToMedia)($mr, "margin-right");
}}

    ${({ $mb }) => {
    return $mb && (0, Responsive_1.responsiveCssToMedia)($mb, "margin-bottom");
}}

    ${({ $ml }) => {
    return $ml && (0, Responsive_1.responsiveCssToMedia)($ml, "margin-left");
}}
`;
//# sourceMappingURL=Text.styles.js.map